import { render, staticRenderFns } from "./executives-retailers-list.vue?vue&type=template&id=33e2ca7d&scoped=true"
import script from "./executives-retailers-list.vue?vue&type=script&lang=js"
export * from "./executives-retailers-list.vue?vue&type=script&lang=js"
import style0 from "./executives-retailers-list.vue?vue&type=style&index=0&id=33e2ca7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2ca7d",
  null
  
)

export default component.exports